import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/style.css';
import Spinner from "../common/Spinner";
import { toast } from "react-toastify";
import { sendGroupInvitations } from "../../redux/actions/groupActions";

function EmailGroupMemberInvitationsControl({
    user,
    group,
    emails,
    sendGroupInvitations,
    onChangeInvites,
    onCompletedInvites
}) {

    const [processing, setProcessing] = useState(false);

    useEffect(() => {


    }, [])

    function sendInvitations() {
        setProcessing(true); 
        sendGroupInvitations(group.id, emails)
            .then(() => {
                setProcessing(false);
                toast.success(`${emails.length} Invitations Sent!`);
                onChangeInvites([]);
                onCompletedInvites(); 
            }) 
    }

    return (
        processing ?
            <Spinner />
            : 
            <div className="add-user-search col-12">
                <div className="tab-header"> 
                    <h4>Send Group Invites</h4>
                </div>
                <div className="tab-body">
                    <p>
                        Enter one or more emails below and hit send to invite multiple
                        people to join your group.
                    </p>
                    <p>
                        Whether they are an existing JustGoRide member
                        or new to the site, either way they will be seamlessly guided to your group to
                        start participating with your discussions and ride planning! 
                    </p>
                    <ReactMultiEmail
                        placeholder="Enter some emails here!"
                        emails={emails}
                        onChange={(_emails) => {
                            onChangeInvites(_emails);
                        }}
                        validateEmail={email => {
                            return isEmail(email);
                        }}
                        getLabel={(
                            email,
                            index,
                            removeEmail
                        ) => {
                            return (
                                <div data-tag key={index}>
                                    {email}
                                    <span data-tag-handle onClick={() => removeEmail(index)}>
                                        ×
                                    </span>
                                </div>
                            );
                        }}
                    />
                    <p className="invite-count">{emails.length > 0 && `${emails.length} invitation${emails.length === 1 ? ' ' : 's '}created`}</p>
                    <button className="btn btn-info float-right" onClick={sendInvitations} disabled={emails.length === 0}>Send Invitation{emails.length > 1 && 's'}</button>
                    <button className="btn btn-link float-right" onClick={(_emails) => {onChangeInvites([]);}} disabled={emails.length === 0}>Clear</button>
                </div>
            </div>
    );
};

EmailGroupMemberInvitationsControl.propTypes = {
    group: PropTypes.object.isRequired,
    invitations: PropTypes.array.isRequired,
    sendGroupInvitations: PropTypes.func.isRequired,
    onChangeInvites: PropTypes.func,
    onCompletedInvites: PropTypes.func
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

const mapDispatchToProps = {
    sendGroupInvitations
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailGroupMemberInvitationsControl);


// WEBPACK FOOTER //
// ./src/components/groups/EmailGroupMemberInvitationsControl.js